import React from 'react';
import {Formik} from "formik";
import {useStepStore} from "react-step-machine";

const FormStep = ({
    name, children,
    initialValues, validationSchema, onNext
}) => {
    const {activeStep} = useStepStore();

    const onSubmit = async (values, actions) => {
        console.log(`Step ${activeStep} values:`, values)
        const onNextData = await onNext(values);
        actions.setSubmitting(false)
        return onNextData;
    }

    return (
        <div className='wizardStepContainer'>
            <h2>{name}</h2>
            <div className='wizardStepForm'>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                    validateOnMount={true}
                    validateOnChange={true}
                    onSubmit={onSubmit}
                >
                     {children}
                </Formik>
            </div>
        </div>
    )
}

export default FormStep;